// extracted by mini-css-extract-plugin
module.exports = {"fill":"styles_fill__39x8m"};